/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_InconsistencyInputs */



/**
* | output |
* | --- |
* | "Inconsistency between AHU(s)" |
*
* @param {Air_Handler_Unit_InconsistencyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_inconsistency = /** @type {((inputs?: Air_Handler_Unit_InconsistencyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_InconsistencyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Inconsistency between AHU(s)")
	return /** @type {LocalizedString} */ ("Incohérence entre les CTA(s)")
});